import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';

import { oturumuKapat } from '../services/authApi';

function Logout() {
  const [tamam, setTamam] = useState(false);

  useEffect(() => {
    oturumuKapat();
    setTamam(true);
  }, []);

  if (!tamam) return null;

  return <Redirect to="/login" />;
}

export default Logout
